export default {"src":"/_next/static/media/healthcare.238aa72a.svg","height":36,"width":36};